export type MediaType = 'PDF' | 'IMAGE' | 'VIDEO' | 'FILE';

export const getMediaType = (file?: File): MediaType | undefined => {
  if (!file) {
    return undefined;
  }
  const mediaType = file?.type;
  if (mediaType?.includes('pdf')) {
    return 'PDF';
  }
  if (mediaType?.includes('image')) {
    return 'IMAGE';
  }
  if (mediaType?.includes('video')) {
    return 'VIDEO';
  }
  return 'FILE';
};

export const imageMimeTypes = ['image/jpg', 'image/jpeg', 'image/png', 'image/webp', 'image/jfif'];

export const photoUploadMimeTypes = ['image/png', 'image/jpeg', 'image/webp', 'image/svg+xml'];

export const videoMimeTypes = ['video/mp4', 'video/avi', 'video/x-matroska', 'video/x-ms-wmv'];

export const pdfMimeTypes = ['application/pdf'];

export const mediaMimeType = [...imageMimeTypes, ...videoMimeTypes];

export const stringImageMimeType: string = imageMimeTypes.join(',');
export const stringPhotoUploadMimeType: string = photoUploadMimeTypes.join(',');
export const stringMediaMimeType: string = mediaMimeType.join(',');
export const stringPdfMimeType: string = pdfMimeTypes.join(',');

export const isImage = (mimeType: string) => imageMimeTypes.includes(mimeType);
export const isVideo = (mimeType: string) => videoMimeTypes.includes(mimeType);
export const isPDF = (mimeType: string) => pdfMimeTypes.includes(mimeType);
